import styled from 'styled-components'

export const StyledMonthAllocationsTable = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 2rem;
`
